import { Component, computed, effect, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectInputComponent } from '@navstation-portal/shared/ui/components';
import { injectDispatch } from '@ngrx/signals/events';
import { SelectOption } from '@navstation-portal/shared/data-model/common';
import {
  AbstractStoreConnectedSectionComponent,
  OffshoreOperationalFormStore,
  offshoreOperationalEvents,
} from '@navstation-portal/reporting/data-access/offshore-report';
import {
  EVENT_OPTIONS,
  CategorisedSelectOption,
  OPERATION_OPTIONS,
  OffshoreEventType,
} from '@navstation-portal/reporting/data-model/offshore-report';

@Component({
  selector: 're-offshore-reporting-options',
  templateUrl: './offshore-reporting-options.component.html',
  imports: [SelectInputComponent, FormsModule],
})
export class OffshoreReportingOptionsComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'reportOptions';
  offshoreOperationalStore = inject(OffshoreOperationalFormStore);
  events = injectDispatch(offshoreOperationalEvents);
  readonly eventOptions: SelectOption[] = EVENT_OPTIONS;

  filteredOperationOptions = computed(() => {
    const event = this.offshoreOperationalStore.reportOptions().eventType.value;
    if (!event) return [];

    return this.filterOperationsByEvent(event);
  });

  constructor() {
    super();
    effect(() => {
      const reportOptions = this.offshoreOperationalStore.reportOptions();
      const filteredOperationOptions = this.filteredOperationOptions();
      if (
        !filteredOperationOptions
          .map((o) => o.name)
          .includes(reportOptions.operationType.value?.name ?? '')
      ) {
        this.events.updateFormStateValue({
          sectionId: this.sectionId,
          fieldId: 'operationType',
          value: undefined,
        });
      }
    });
  }

  filterOperationsByEvent(
    event: SelectOption | undefined,
  ): SelectOption[] | [] {
    if (!event) return [];
    const filtered = OPERATION_OPTIONS.filter(
      (option: CategorisedSelectOption) =>
        !option?.categories ||
        option.categories.includes(event.code as OffshoreEventType),
    );
    return filtered;
  }
}
